module.exports = __webpack_public_path__ + "img/1ad43fa.jpg";